import { Component } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { map } from 'rxjs/operators';

import {
  generateCustomIndexFn,
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { injectFlags } from '@shared/services/launch-darkly.service';

@Component({
  imports: [RouterOutlet, RouteTabGroupComponent],
  template: `
    <div class="relative -mt-7 mb-7">
      <aux-route-tab-group [tabs]="tabs" [indexFn]="indexFn" [ignoreFullLayout]="true" />
    </div>
    <router-outlet />
  `,
})
export class InvestigatorForecastPageComponent {
  flags = injectFlags({
    investigator_forecast_settings: 'investigator_forecast_settings',
    tab_forecast_investigator_forecast: 'tab_forecast_investigator_forecast',
  });

  flags$ = toObservable(this.flags);
  indexFn = generateCustomIndexFn(
    `${ROUTING_PATH.INVESTIGATOR.INDEX}/${ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST.INDEX}`
  );
  tabs: TabGroupConfig[] = [
    {
      label: 'Forecast Table',
      route: ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST.TABLE,
      show: this.flags$.pipe(map((flags) => flags.tab_forecast_investigator_forecast)),
    },
    {
      label: 'Forecast Settings',
      route: ROUTING_PATH.INVESTIGATOR.INVESTIGATOR_FORECAST.SETTINGS,
      show: this.flags$.pipe(map((flags) => flags.investigator_forecast_settings)),
    },
  ];
}
